import React, { useRef, useEffect, useContext, useState } from "react";
import { Button, Input, Divider, Modal, Space, message, Popover } from "antd";
import { getVipItems, getCreditsItems, getCreditsBuy, getVipBuy, getCreditsDetails, getDiscountCode, getUpgradePrice, getOrderStatus } from "@/apis/vip";
import PAY from "./image/pay.png";
import INFO from "./image/info.svg";
import GOU from "./image/gou.svg";
import ERR from './image/err.svg'
import BASIC from "./image/basic.png";
import SUPER from "./image/企业会员图标.png";
import PAY_ICON from "./image/pay_icon.png";
import LOAD from "./image/load.png";
import SUCCESS from "./image/success.svg";
import { DataContext } from "@/context";
import "./index.scss";
import { useNavigate } from 'react-router-dom';
import Header from "@/components/Header";
import { debounce } from "lodash";
import { detectDevice } from '@/utils'
import { ComputeUsageModal } from "@/components/ComputeUsageModal/ComputeUsageModal";
import { BuyComputeModal } from "@/components/BuyComputeModal/BuyComputeModal";
import { NewYearBtn } from "@/components/NewYearBtn";
import { useActivityConfig } from "@/hooks/useActivityConfig";
import NewYearCoupon from "@/assets/new_year_activity/优惠券@2x.png";
const QR_KF = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/1.png'
interface Props {
    userOtherInfo: any;
    payCountObj: any;
}

const PAY_LINK = 'https://mi8elatzm1x.feishu.cn/wiki/Ms0cwYLRZiY3UbkKL7xckq9OnUe';

export const formatDate = (date) => {
    const padZero = (num) => String(num).padStart(2, '0');

    return [
        date.getFullYear(),
        padZero(date.getMonth() + 1), // 月份从 0 开始
        padZero(date.getDate()),
    ].join('-') + ' ' + [
        padZero(date.getHours()),
        padZero(date.getMinutes()),
    ].join(':');
}

const defaultVipObj = {
    month: {
        basic: {
            logo: "/price/会员图标@4x.svg",
            // perMonth: "每月￥39",
            perHundredCount: "￥7.16/100 算力",
            perMonthCount: "800点算力 每月",
            money: '49',
            money1: '199',
            count: '1800',
            images: '1800',
            desc: [
                'VIP专属做图专家指导',
                '4k分辨率出图',
                '去水印',
                '免排队高速GPU池',
            ]
        },
        pro: {
            logo: "/price/会员图标@4x.svg",
            // perMonth: "每月￥166.58",
            perHundredCount: "￥6.30/100 算力",
            perMonthCount: "800点算力 每月",
            money: '189',
            money1: '289',
            count: '3000',
            images: '3000',
            desc: [
                'VIP专属做图专家指导',
                '4k分辨率出图',
                '去水印',
                '免排队高速GPU池',
                '每天20次免费使用Midjourney',
                '每天20次免费使用Nano banana2 Pro',
                '每天20次免费使用SeeDream 4.0',
                '高级功能使用权限',
                '新功能共创与新版本内测体验'
            ]
        },
        super: {
            logo: "/price/会员图标@4x.svg",
            // perMonth: "每月￥833.25",
            perHundredCount: "￥4.89/100 算力",
            perMonthCount: "800点算力 每月",
            money: '1099',
            money1: '689',
            count: '10000',
            images: '10000',
            desc: [
                'VIP专属做图专家指导',
                '4k分辨率出图',
                '去水印',
                '免排队高速GPU池',
                '每天20次免费使用Midjourney',
                '每天20次免费使用Nano banana2 Pro',
                '每天20次免费使用SeeDream 4.0',
                '高级功能使用权限',
                '新功能共创与新版本内测体验'
            ]
        },
        company: {
            logo: SUPER,
            // perMonth: "每月￥833.25",
            perHundredCount: "￥5.5/100 算力",
            perMonthCount: "800点算力 每月",
            money: '1099',
            money1: '1199',
            count: '20000',
            images: '20000',
            desc: [
                'VIP专属做图专家指导',
                '4k分辨率出图',
                '去水印',
                '免排队高速GPU池',
                '新功能共创与新版本内测体验',
                '专属AI做图专家1对1指导及课程培训',
                '独家模型训练服务',
                '定制AI模特训练服务',
                '定制工作流搭建服务',
                '专属功能定制化开发服务',
                '更多专属定制化服务',
            ]
        },
    },
    year: {
        basic: {
            logo: "/price/会员图标@4x.svg",
            perMonth: "￥107.5元/月",
            perHundredCount: "",
            perMonthCount: "800点算力 每月",
            money: '468',
            money1: '1990',
            count: '1800',
            images: '1800',
            desc: [
                'VIP专属做图专家指导',
                '4k分辨率出图',
                '去水印',
                '免排队高速GPU池',
            ]
        },
        pro: {
            logo: "/price/会员图标@4x.svg",
            perMonth: "￥157.5元/月",
            perHundredCount: "",
            perMonthCount: "800点算力 每月",
            money: '1999',
            money1: '2890',
            count: '3000',
            images: '3000',
            desc: [
                'VIP专属做图专家指导',
                '4k分辨率出图',
                '去水印',
                '免排队高速GPU池',
                '每天20次免费使用Midjourney',
                '每天20次免费使用Nano banana2 Pro',
                '每天20次免费使用SeeDream 4.0',
                '高级功能使用权限',
                '新功能共创与新版本内测体验'
            ]
        },
        super: {
            logo: "/price/会员图标@4x.svg",
            perMonth: "￥407.5元/月",
            perHundredCount: "",
            perMonthCount: "800点算力 每月",
            money: '9999',
            money1: '6890',
            count: '10000',
            images: '10000',
            desc: [
                'VIP专属做图专家指导',
                '4k分辨率出图',
                '去水印',
                '免排队高速GPU池',
                '每天20次免费使用Midjourney',
                '每天20次免费使用Nano banana2 Pro',
                '每天20次免费使用SeeDream 4.0',
                '高级功能使用权限',
                '新功能共创与新版本内测体验'
            ]
        },
        company: {
            logo: SUPER,
            perMonth: "每月￥833.25",
            perHundredCount: "",
            perMonthCount: "800点算力 每月",
            money: '9999',
            money1: '10999',
            count: '20000',
            images: '20000',
            desc: [
                'VIP专属做图专家指导',
                '4k分辨率出图',
                '去水印',
                '免排队高速GPU池',
                '新功能共创与新版本内测体验',
                '专属AI做图专家1对1指导及课程培训',
                '独家模型训练服务',
                '定制AI模特训练服务',
                '定制工作流搭建服务',
                '专属功能定制化开发服务',
                '更多专属定制化服务',
            ]
        },
    }
}

const Price: React.FC<Props> = (props: Props) => {
    const searchParamsString = window.location.href.split('?')[1] || '';
    const searchParams = new URLSearchParams(searchParamsString);
    const openCredit = searchParams.get('openCredit') || ''
    const { activityConfig } = useActivityConfig()
    const [messageApi, contextHolder] = message.useMessage();
    const isPc = detectDevice()

    const { userOtherInfo, payCountObj } = props;
    const navigate = useNavigate();

    const childRef = useRef<any>(null);

    const [select, setSelect] = useState('year');
    const [vipType, setVipType] = useState({ id: "none", vip_type: 'none' });
    const [selectVipPayObj, setselectVipPayObj] = useState({} as any);
    const [selectVipPaySuccess, setSelectVipPaySuccess] = useState('');

    const [vipList, serVipList] = useState<any[]>([]);

    const [selectCount, setSelectCount] = useState(0);
    const [selectCountPayObj, setSelectCountPayObj] = useState({} as any);
    const [selectCountPaySuccess, setSelectCountPaySuccess] = useState('');
    // const [selectCountDiscount, setSelectCountDiscount] = useState('');

    const [selectVipDiscount, setSelectVipDiscount] = useState('');
    const [discountValue, setDiscountValue] = useState({} as any)

    const [countList, setCountList] = useState([]);

    const [selectUseCount, setSelectUseCount] = useState('all')
    const [useCountList, setUseCountList] = useState([]);

    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const [contactSalesOpen, setContactSalesOpen] = useState(false)
    const [newYearCouponOpen, setNewYearCouponOpen] = useState(false)
    const [wechatServiceOpen, setWechatServiceOpen] = useState(false)
    const {
        userInfo,
        setContextValue
    } = useContext(DataContext);

    const [changePayTypeObj, setChangePayTypeObj] = useState<any>({})

    const timer = useRef(null)
    const timer1 = useRef(null)

    useEffect(() => {
        const workGetVipItems = async () => {
            const result = await getVipItems().catch(err => {
                messageApi.open({
                    type: 'error',
                    content: err,
                });
            });
            const defaultVipObj = [
                // 不再展示企业会员
                // {
                //     "id": 9999,
                //     "name": "企业会员",
                //     "credits": 10000,
                //     "price": 109900,
                //     "vip_duration": 1,
                //     "vip_duration_type": "month",
                //     "credits_expire_duration": 1,
                //     "credits_expire_duration_type": "month",
                //     "vip_type": "company",
                //     "current_vip_residual_value": 0
                // },
                // {
                //     "id": 9998,
                //     "name": "企业会员",
                //     "credits": 10000,
                //     "price": 999900,
                //     "vip_duration": 1,
                //     "vip_duration_type": "year",
                //     "credits_expire_duration": 1,
                //     "credits_expire_duration_type": "year",
                //     "vip_type": "company",
                //     "current_vip_residual_value": 0
                // }
            ]
            if (Array.isArray(result) && result.length) {
                const sortByOrder = (orderArr: any[], dataArr: any[], key: string) => {
                    // 先给 orderArr 建立 “值 → 索引” 的映射，后面排序直接查表，复杂度 O(1)
                    const orderMap = new Map(orderArr.map((v, i) => [v, i]));

                    // 复制一份再排序，避免副作用
                    return [...dataArr].sort((a, b) => {
                        const aIndex = orderMap.get(a[key]);
                        const bIndex = orderMap.get(b[key]);

                        // 如果数据里出现了 orderArr 中没有的值，统一放最后
                        if (aIndex === undefined) return 1;
                        if (bIndex === undefined) return -1;
                        return aIndex - bIndex;
                    });
                }
                const vipTypeList = ['basic', 'pro', 'super']
                const sortResultList = sortByOrder(vipTypeList, result, 'vip_type')
                const list = [...sortResultList, ...defaultVipObj]
                serVipList(list)
            } else {
                const list = [...defaultVipObj]
                serVipList(list)
            }
        };

        const workGetCreditsItems = async () => {
            const result = await getCreditsItems().catch(err => {
                messageApi.open({
                    type: 'error',
                    content: err,
                });
            });
            if (Array.isArray(result) && result.length) {
                setCountList(result)
            } else {
                setCountList([])
            }
        };

        // vip 列表
        workGetVipItems();
        // 点数 列表
        workGetCreditsItems();
    }, [])

    useEffect(() => {
        if (selectCountPayObj?.id) {
            const timeOutFun = async () => {
                const reCall = () => {
                    timer.current = setTimeout(async () => {
                        await timeOutFun()
                    }, 3000)
                }
                await getOrderStatus({
                    order_id: selectCountPayObj?.id
                }).then(res => {
                    if (res?.status === 'created') {
                        reCall()
                    } else if (res?.status === 'paid') {
                        setSelectCountPaySuccess('paid')
                        clearTimeout(timer.current)
                    } else if (res?.status === 'expired') {
                        setSelectCountPaySuccess('expired')
                        clearTimeout(timer.current)
                    } else {
                        reCall()
                    }
                }).catch(err => {
                    messageApi.open({
                        type: 'error',
                        content: err,
                    });

                    clearTimeout(timer.current)
                })
            }
            timeOutFun()
        } else {
            clearTimeout(timer.current)
        }
    }, [selectCountPayObj?.id])

    useEffect(() => {
        if (selectVipPayObj?.id) {
            const timeOutFun = async () => {
                const reCall = () => {
                    timer1.current = setTimeout(async () => {
                        await timeOutFun()
                    }, 3000)
                }
                await getOrderStatus({
                    order_id: selectVipPayObj?.id
                }).then(res => {
                    if (res?.status === 'created') {
                        reCall()
                    } else if (res?.status === 'paid') {
                        setSelectVipPaySuccess('paid')
                        setNewYearCouponOpen(true)
                        // 设置付款完成标记，回到首页时不再展示弹框
                        localStorage.setItem('paymentCompleted', 'true');
                        clearTimeout(timer1.current)
                    } else if (res?.status === 'expired') {
                        setSelectVipPaySuccess('expired')
                        clearTimeout(timer1.current)
                    } else {
                        reCall()
                    }
                }).catch(err => {
                    console.log(err)
                    clearTimeout(timer1.current)
                })
            }
            timeOutFun()
        } else {
            clearTimeout(timer1.current)
        }
    }, [selectVipPayObj?.id])

    useEffect(() => {
        const current = vipList.find(item => {
            if (item?.vip_duration_type == select && item.vip_type == "pro") {
                return true
            }
        })
        if (current) {
            handleVipItem(current)
        }
    }, [select, userInfo?.user_id])

    // pay 算力
    const workCreditsBuy = async (count) => {
        const result = await getCreditsBuy({
            item_id: count,
            // ...(discount ? {discount_code: discount} : {}),
        }).catch(err => {
            messageApi.open({
                type: 'error',
                content: err,
            });
        });
        // console.log('czr', result)
        if (result?.url && result?.id) {
            setSelectCountPayObj(result)
        } else {
            setSelectCountPayObj({} as any)
        }
    };

    // pay vip
    const workVipBuy = async (obj, codeObj = { code: null }) => {
        await getVipBuy({
            item_id: obj?.id,
            ...(codeObj?.code ? { discount_code: codeObj?.code } : {}),
            // return_url: 'https://cemeta.cn/#/price'
        }).then(res => {
            // console.log(res, 'workVipBuy - res')
            if (res?.url && res?.id) {
                if (codeObj?.code) {
                    setDiscountValue(codeObj)
                    messageApi.open({
                        type: 'success',
                        content: '已应用折扣',
                    });
                }

                setselectVipPayObj(res)
                !codeObj?.code && setOpen2(true)
            } else {
                setselectVipPayObj({})
            }
        }).catch(err => {
            messageApi.open({
                type: 'error',
                content: err,
            });
        });

    };

    // useEffect(() => {
    //     if (discountValue?.code && vipType?.id) {

    //     }
    // }, [discountValue?.code])

    useEffect(() => {
        const workGetCreditsDetails = async () => {
            await getCreditsDetails({
                limit: 999,
                offset: 0,
                type: selectUseCount
            }).then(res => {
                if (res?.count && Array.isArray(res?.list) && res?.list?.length) {
                    setUseCountList(res?.list)
                } else {
                    setUseCountList([])
                }
            }).catch(err => {
                messageApi.open({
                    type: 'error',
                    content: err,
                });
            });
            // console.log('vipurl', result)

        };
        if (open3) {
            workGetCreditsDetails();
        }
    }, [open3, selectUseCount])

    useEffect(() => {
        if (openCredit && userInfo?.user_id) {
            handleBuyCount()
        }
    }, [openCredit, userInfo?.user_id])

    const handleVipItem = (obj) => {
        setVipType(obj)
    }

    const handleBuyCount = debounce(() => {
        if (userInfo?.vip_type === 'company') {
            messageApi.error('您已是企业会员，无法叠加个人会员权益')
            return
        }
        if (userInfo?.user_id) {
            setSelectCount(1)
            // workCreditsBuy(1);
            setOpen1(true)
        } else {
            if (childRef.current) {
                childRef.current?.openLogin(); // 触发子组件按钮点击
            }
        }
    }, 800)

    const handleBuyVip = (obj) => {
        const work = async () => {
            await getUpgradePrice({ item_id: obj?.id })
                .then(res => {
                    setChangePayTypeObj(res)
                    workVipBuy(obj)
                })
                .catch(err => {
                    messageApi.open({
                        type: 'error',
                        content: err,
                    });
                })
        }
        if (userInfo?.user_id) {
            work()
        } else {
            if (childRef.current) {
                childRef.current?.openLogin(); // 触发子组件按钮点击
            }
        }
    }

    const handleOpen3 = debounce(() => {
        if (userInfo?.user_id) {
            setOpen3(true)
        } else {
            if (childRef.current) {
                childRef.current?.openLogin(); // 触发子组件按钮点击
            }
        }
    }, 800)

    const handleOpenContact = debounce(() => {
        if (userInfo?.user_id) {
            onOpenContact()
        } else {
            if (childRef.current) {
                childRef.current?.openLogin(); // 触发子组件按钮点击
            }
        }
    }, 800)
    const onOpenContact = () => {
        setContactSalesOpen(true)
    }
    const onCancelContace = () => {
        setContactSalesOpen(false)
    }


    const handleCountSelect = (item) => {
        setSelectCount(item?.id)
        workCreditsBuy(item?.id)
    }

    const handleOpen1Close = () => {
        setSelectCountPayObj({})
        setOpen1(false)
        setSelectCountPaySuccess('')
    }

    const handleOpen2Close = () => {
        setSelectVipDiscount('')
        setselectVipPayObj({})
        setOpen2(false)
        setSelectVipPaySuccess('')
        setDiscountValue({})
    }

    const handleOpen3Close = () => {
        setOpen3(false)
    }

    const handleNewYearCouponClose = () => {
        setNewYearCouponOpen(false)
        setWechatServiceOpen(true)
    }

    const handleWechatServiceClose = () => {
        setWechatServiceOpen(false)
    }

    const handleJumpInvite = () => {
        if (userInfo?.user_id) {
            searchParams.delete('y');
            navigate({ pathname: '/invite', search: '?' + searchParams.toString() });
        } else {
            if (childRef.current) {
                childRef.current?.openLogin(); // 触发子组件按钮点击
            }
        }
    }

    const renderItemText = (item) => {
        // console.log(userOtherInfo, 'userOtherInfo')
        // console.log(item, 'item')
        /*  逻辑: 
            当前用户无会员时: 默认展示订阅
            当前用户的会员等级和列表中相同时: 展示续订
            当前用户会员等级低于列表会员等级: 展示升级
            当前用户会员等级高于列表会员等级: 展示订阅 同时禁用购买功能
        */
        // 用索引表示等级
        const vipList = ['basic', 'pro', 'super']
        const userVip = userOtherInfo.vip_type //'pro' //
        const userVipIndex = vipList.findIndex(item => item == userVip)
        const itemVip = item?.vip_type
        const itemVipIndex = vipList.findIndex(item => item == itemVip)
        if (userOtherInfo.vip_type === 'company') {
            return {
                disabled: true,
                text: '订阅'
            }
        }
        if (userVipIndex != -1 && itemVipIndex != -1) {
            if (userVipIndex == itemVipIndex) {
                return {
                    disabled: false,
                    text: '续订'
                }
            }
            if (userVipIndex < itemVipIndex) {
                return {
                    disabled: false,
                    text: '升级'
                }
            }
            if (userVipIndex > itemVipIndex) {
                return {
                    disabled: true,
                    text: '订阅'
                }
            }
        }

        return {
            disabled: false,
            text: '订阅'
        }
    }

    const getMessage = (obj) => {
        let message = []
        if (obj.recharge?.restPay && obj.recharge?.restTime) {
            const { restPay, restTime } = obj.recharge
            message.push(`您充值的${restPay}算力: 将于${restTime}到期`)
        }
        if (obj.subscribe?.restPay && obj.subscribe?.restTime) {
            const { restPay, restTime } = obj.subscribe
            message.push(`您订阅的${restPay}算力: 将于${restTime}到期`)
        }
        if (obj.gift?.restPay && obj.gift?.restTime) {
            const { restPay, restTime } = obj.gift
            message.push(`您受赠的${restPay}算力: 将于${restTime}到期`)
        }
        return message
    }

    const renderMessage = (array) => {
        return (
            <div style={{ color: '#ffffff', fontSize: '14px', lineHeight: '22px' }}>
                {
                    array?.map((item, index) => (
                        <div key={index}>{item}</div>
                    ))
                }
            </div>
        )
    }
    // console.log('payCountObj', payCountObj)

    const handleOnChange = (e) => {
        // console.log(e.target.value)
        setSelectVipDiscount(e.target.value)
    }

    const workUseDiscount = async () => {
        await getDiscountCode({ code: selectVipDiscount })
            .then(res => {
                // if (res?.amount == 0) {
                //     messageApi.open({
                //         type: "warning",
                //         content: '当前折扣码无可用次数',
                //     });
                //     return 
                // }
                if (res?.code) {
                    setSelectVipDiscount('')

                    workVipBuy(vipType, res)
                }
            })
            .catch(err => {
                messageApi.open({
                    type: 'error',
                    content: err,
                });
            })
    };
    const handleUseDiscount = debounce(() => {
        if (discountValue?.amount || discountValue?.percent) {
            messageApi.open({
                type: 'error',
                content: '当前套餐已使用折扣码，可关闭弹窗重新应用新的折扣码',
            });
        } else {
            workUseDiscount()
        }
    }, 800)
    // console.log(select, vipType?.vip_type, defaultVipObj[select][vipType?.vip_type]?.money)
    return (
        <>
            {contextHolder}
            <div className="price">
                <Header ref={childRef} {...props} />
                <div className="wapper" style={isPc ? { marginTop: '70px' } : { marginTop: '15em' }}>
                    <div className="price-title" style={isPc ? { marginTop: '80px' } : { lineHeight: '3em', fontSize: '2.5em' }}>
                        <span>订阅生图会员</span>
                        {/* 无法实现 ，还能接设计商单*/}
                        {/* <span>订阅生图会员，还能接设计商单</span> */}
                    </div>
                </div>
                <div className="price-description">
                    <span>选择合适您的套餐，或直接</span> <span className="price-description-buy" onClick={handleBuyCount}>购买算力</span>
                </div>
                <div className="wapper" style={{ marginTop: '48px' }}>
                    <div className="current-pay-count">
                        <span>当前算力：</span>
                        <img style={{ width: '20px', height: '20px', marginRight: '4px' }} src={PAY} alt="pay" />
                        <span>{userInfo?.user_id ? payCountObj?.recharge?.pay + payCountObj?.subscribe?.pay + payCountObj?.gift?.pay + payCountObj?.old?.pay : 0}</span>
                        {userInfo?.user_id && (payCountObj?.recharge?.restPay || payCountObj?.subscribe?.restPay || payCountObj?.gift?.restPay || payCountObj?.old?.restPay)
                            ? (
                                <Popover
                                    getPopupContainer={(trigger: any) => trigger.parentElement}
                                    content={renderMessage(getMessage(payCountObj))}
                                    placement="right"
                                    color="#2B303B"
                                >
                                    <img style={{ width: '16px', height: '16px', marginLeft: '4px' }} src={INFO} alt="info" />
                                </Popover>
                            )
                            : null
                        }
                        <div className="buy-text" onClick={handleBuyCount}>
                            <span>购买算力</span>
                        </div>
                    </div>
                </div>
                <div className="wapper" style={{ marginTop: '16px' }}>
                    <span className="price-detail" onClick={handleOpen3}>{'算力消耗明细 >'}</span>
                </div>
                <div className="wapper" style={{ marginTop: '48px' }}>
                    <div className="price-select">
                        <div className={`price-select-item ${select === 'year' ? 'item-select' : ''}`} style={isPc ? { marginRight: '12px' } : { marginRight: '12px', width: '12em' }} onClick={() => setSelect('year')}>
                            <span>包年购买</span>
                            {activityConfig?.vip_new_year_promotion?.use_config ? <div className="new-year-btn-container">
                                <NewYearBtn>
                                    <div className="px-3 py-[1px] ml-[2px]">新春福利</div>
                                </NewYearBtn>
                            </div> : <span className={`price-select-item-discount`}>
                                免费2个月
                                {/* 节省30% */}
                            </span>}
                        </div>
                        <div className={`price-select-item ${select === 'month' ? 'item-select' : ''}`} style={isPc ? {} : { width: '12em' }} onClick={() => setSelect('month')}>
                            <span>单月购买</span>
                        </div>
                    </div>

                </div>
                <div className="wapper" style={{ marginTop: '28px' }}>
                    {/* 12.1暂时隐藏 */}
                    {false ? <div style={{ background: '#232b2f', color: '#ffffff', width: '800px', height: '200px', borderRadius: '24px', textAlign: 'center', lineHeight: '200px', fontSize: '24px', fontWeight: 800 }}>
                        <span>敬请期待！</span>
                    </div> : <div className={`price-list flex ${isPc ? "flex-row" : "flex-col justify-center"}`}>
                        {
                            select === 'year'
                                ? null
                                : (
                                    <div className={`price-list-item ${vipType?.vip_type === "none" ? 'price-list-item-select' : ''}`} onClick={() => {
                                        if (userOtherInfo?.user_id) {
                                            return
                                        }
                                        handleVipItem({ id: "none", vip_type: "none" })
                                    }}>
                                        {
                                            !userOtherInfo?.vip_type && userOtherInfo?.valid_invite_count >= 10
                                                ? (
                                                    <div className="price-list-item-tag">
                                                        <span>当前免费</span>
                                                    </div>
                                                )
                                                : null
                                        }
                                        <div className="price-member-type">
                                            <span>免费版</span>
                                        </div>
                                        <div className="price-money h-[42px]" style={{ marginTop: '12px' }}>
                                            <div className="price-money-per">￥</div>
                                            <div className="price-money-number">0</div>
                                        </div>
                                        <div className="price-month-money" style={{ marginTop: '8px' }}>
                                            <span>永久</span>
                                            {/* <span>7天有效期</span> */}
                                        </div>
                                        <button className="price-button-to-buy" style={{ marginTop: '28px', background: userOtherInfo?.user_id ? "#ababab" : "", cursor: userOtherInfo?.user_id ? "no-drop" : "" }} onClick={debounce(() => {
                                            if (userOtherInfo?.user_id) {
                                                return
                                            }
                                            if (childRef.current) {
                                                childRef.current?.openLogin(false); // 触发子组件按钮点击
                                            }
                                        }, 800)}>
                                            <span>{(() => {
                                                if (userOtherInfo?.user_id) {
                                                    if (userOtherInfo.vip_type) {
                                                        return '免费'
                                                    }
                                                    return "当前计划"
                                                }
                                                return "注册"

                                            })()}</span>
                                        </button>
                                        {/* <div className="price-button-to-buy" style={{ marginTop: '28px' }} onClick={handleJumpInvite}>
                                        <span>邀请10位用户生图 自动领取</span>
                                    </div> */}
                                        {/* <div className="price-about" style={{ marginTop: '16px' }}>
                                        <div className="price-about-first">
                                            <img style={{ width: '16px', height: '16px', marginRight: '6px' }} src={PAY} />
                                            <span>100点算力/周</span>
                                        </div>
                                        <Divider style={{ background: '#3c4246', margin: '8px 0px'}} />
                                        <div className="price-about-first" style={{ color: '#a4a7a9' }}>
                                            <span>约生成100张图片</span>
                                        </div>
                                    </div> */}
                                        <div className="price-member-info" style={{ marginTop: '24px' }}>
                                            {/* <div className="price-member-info-item">
                                            <img style={{ width: '16px', height: '16px' }} src={GOU} />
                                            <span>高速 GPU 池</span>
                                        </div>
                                        <div className="price-member-info-item">
                                            <img style={{ width: '16px', height: '16px' }} src={GOU} />
                                            <span>高级功能使用权益</span>
                                        </div>
                                        <div className="price-member-info-item">
                                            <img style={{ width: '16px', height: '16px' }} src={GOU} />
                                            <span>专属算力引擎</span>
                                        </div>
                                        <div className="price-member-info-item">
                                            <img style={{ width: '16px', height: '16px' }} src={GOU} />
                                            <span>7天打卡培训计划</span>
                                        </div>
                                        <div className="price-member-info-item">
                                            <img style={{ width: '16px', height: '16px' }} src={GOU} />
                                            <span>创造大使直通名额</span>
                                        </div>
                                        <div className="price-member-info-item">
                                        </div> */}
                                            <div className="price-member-info-item">
                                                <img src={GOU} />
                                                使用所有模型
                                            </div>
                                            <div className="price-member-info-item">
                                                <img src={ERR} />
                                                高级功能使用权限
                                            </div>
                                            <div className="price-member-info-item">
                                                <img src={ERR} />
                                                去水印
                                            </div>
                                        </div>
                                    </div>
                                )
                        }
                        {
                            vipList?.filter(item => item?.vip_duration_type === select)?.length
                                ? (
                                    vipList?.filter(item => item?.vip_duration_type === select)?.map(item => {
                                        const { disabled, text } = renderItemText(item)
                                        return (
                                            <div key={item?.id} className={`price-list-item ${vipType?.vip_type === item?.vip_type ? 'price-list-item-select' : ''}`} onClick={() => handleVipItem(item)}>
                                                {
                                                    userOtherInfo?.vip_duration_type === select && userOtherInfo?.vip_type === item?.vip_type
                                                        ? (
                                                            <div className="price-list-item-tag">
                                                                <span>当前会员</span>
                                                            </div>
                                                        )
                                                        : null
                                                }
                                                <div className="price-member-type">
                                                    <img style={['basic', 'pro', 'super'].includes(item?.vip_type) ? { width: 'auto', height: '16px' } : { width: '110px', height: 'auto' }} src={defaultVipObj?.[select]?.[item?.vip_type]?.logo} />
                                                    {['basic', 'pro', 'super'].includes(item?.vip_type) && <div className="ml-2">
                                                        {item.name}
                                                    </div>}
                                                    {(['basic', 'pro', 'super'].includes(item?.vip_type) && item?.vip_duration_type === 'year' && activityConfig?.vip_new_year_promotion?.use_config) && <div className="new-year-price-btn ml-8 ">
                                                        <div className="py-[3px] px-[8px] text-[14px]">多送3个月</div>
                                                    </div>}
                                                </div>
                                                {['basic', 'pro', 'super'].includes(item?.vip_type) && <div className="price-money" style={{ marginTop: '12px' }}>
                                                    <div className="flex items-end flex-end mr-[10px]">
                                                        <div className="price-money-per">￥</div>
                                                        <div className="price-money-number">{Number(item?.price / 100)}</div>
                                                        <div style={{ fontSize: '14px', lineHeight: '20px' }}>{select === 'year' ? "/年" : "/月"}</div>
                                                    </div>
                                                    <div className="price-discount">
                                                        <div className="price-discount-text">
                                                            限时折扣
                                                        </div>
                                                        <div className="price-discount-number">
                                                            ¥ {defaultVipObj?.[select]?.[item?.vip_type]?.money1}
                                                        </div>
                                                    </div>
                                                </div>}
                                                {['basic', 'pro', 'super'].includes(item?.vip_type) && <div className="price-month-money" style={{ marginTop: '8px' }}>
                                                    {select === 'year' ? <span>{defaultVipObj?.[select]?.[item?.vip_type]?.perMonth}</span> : null}<span style={select !== 'year' ? {} : { marginLeft: '8px' }}>{defaultVipObj?.[select]?.[item?.vip_type]?.perHundredCount}</span>
                                                </div>}
                                                {item?.vip_type === 'company' && <div className="price-super">
                                                    <div className="price-super-text">
                                                        定制企业套餐
                                                    </div>
                                                    <div className="price-super-desc">
                                                        联系专属客户经理
                                                    </div>
                                                </div>}
                                                {['basic', 'pro', 'super'].includes(item?.vip_type) && <div className={`price-button-to-buy ${disabled ? "disabled" : ""}`} style={{ marginTop: '28px' }}
                                                    onClick={debounce(() => {
                                                        if (disabled) {
                                                            messageApi.error('您已是企业会员，无法叠加个人会员权益')
                                                            return 
                                                        }
                                                        handleBuyVip(item)
                                                    }, 800)}>
                                                    <span>{text}{item?.name}</span>
                                                </div>}
                                                {item?.vip_type === 'company' && <div className="price-button-to-buy" style={{ marginTop: '28px' }} onClick={handleOpenContact}>
                                                    联系销售团队
                                                </div>}
                                                <div className="price-about" style={{ marginTop: '16px' }}>
                                                    <div className="price-about-first">
                                                        <img style={{ width: '16px', height: '16px', marginRight: '6px' }} src={PAY} />
                                                        <span className=""><span className="price-about-first-number">{defaultVipObj?.[select]?.[item?.vip_type]?.count}</span> 点算力 /月 {item?.vip_type === 'company' && '起'}</span>
                                                    </div>
                                                    <Divider style={{ background: '#3c4246', margin: '8px 0px' }} />
                                                    <div className="price-about-first" style={{ color: '#a4a7a9' }}>
                                                        <span>约生成{defaultVipObj?.[select]?.[item?.vip_type]?.images}张图片 {item?.vip_type === 'company' && '起'}</span>
                                                    </div>
                                                </div>
                                                <div className="price-member-info">
                                                    {defaultVipObj?.[select]?.[item?.vip_type]?.desc?.map(item => {
                                                        return <div className="price-member-info-item">
                                                            <img src={GOU} />
                                                            <span>{item}</span>
                                                        </div>
                                                    })}
                                                </div>

                                                {/* <div className="price-member-info" style={{ marginTop: '24px' }}>
                                            {
                                                item?.vip_type !== 'basic'
                                                    ? (
                                                        <div className="price-member-info-item">
                                                            <img style={{ width: '16px', height: '16px' }} src={GOU} />
                                                            <span>商用授权</span>
                                                        </div>
                                                    )
                                                    : null
                                            }
                                            
                                            <div className="price-member-info-item">
                                                <img style={{ width: '16px', height: '16px', marginRight: '4px' }} src={GOU} />
                                                <span>高速 GPU 池</span>
                                            </div>
                                            <div className="price-member-info-item">
                                                <img style={{ width: '16px', height: '16px', marginRight: '4px' }} src={GOU} />
                                                <span>高级功能使用权益</span>
                                            </div>
                                            <div className="price-member-info-item">
                                                <img style={{ width: '16px', height: '16px', marginRight: '4px' }} src={GOU} />
                                                <span>专属算力引擎</span>
                                            </div>
                                            <div className="price-member-info-item">
                                                <img style={{ width: '16px', height: '16px', marginRight: '4px' }} src={GOU} />
                                                <span>7天打卡培训计划</span>
                                            </div>
                                            <div className="price-member-info-item">
                                                <img style={{ width: '16px', height: '16px', marginRight: '4px' }} src={GOU} />
                                                <span>创造大使直通名额</span>
                                            </div>
                                            <div className="price-member-info-item">
                                            </div>
                                        </div> */}
                                            </div>
                                        )
                                    })
                                )
                                : null
                        }
                    </div>
                    }
                </div>
            </div>

            <BuyComputeModal open={open1} setOpen={setOpen1} payCountObj={payCountObj} userOtherInfo={userOtherInfo} handleOpenCompute={handleOpen3} />
            <Modal
                className="price-model-money"
                width={'420px'}
                title={null}
                footer={null}
                open={open2}
                maskClosable={false}
                onCancel={handleOpen2Close}
            >
                <div className="price-model-money-wapper">
                    {/* <div style={{ color: '#ffffff', fontSize: '18px' }}>
                        <span>敬请期待！</span>
                    </div> */}
                    <div className="price-model-money-title">
                        {/* 旧版方式 */}
                        {/* <span style={{ marginRight: '4px' }}>扫码支付</span> <span>{(discountValue?.amount || discountValue?.percent) ? Number(selectVipPayObj?.price / 100).toFixed(2) : defaultVipObj[select][vipType?.vip_type]?.money}元</span> */}
                        {/* 兼容接口 */}
                        <span style={{ marginRight: '4px' }}>扫码支付</span> <span>{Number(selectVipPayObj?.price / 100).toFixed(2)}元</span>
                    </div>
                    {
                        changePayTypeObj?.current_vip_residual_value ? (
                            <div className="price-model-money-des" style={{ marginTop: '8px', marginBottom: '4px' }}>
                                <span>当前订阅套餐可抵扣{Number(changePayTypeObj?.current_vip_residual_value / 100).toFixed(2)}元，升级后获得{changePayTypeObj?.credits}算力，立即生效</span>
                            </div>
                        ) : null
                    }
                    {
                        discountValue?.amount || discountValue?.percent
                            ? (
                                <div className="price-model-money-des" style={{ marginTop: '8px' }}>
                                    <span>当前应用</span>
                                    {
                                        discountValue?.amount
                                            // ? <span style={{ color: '#FF7B00' }}>抵扣{Number(discountValue?.amount / 100).toFixed(2)}元</span>
                                            ? <span style={{ color: '#FF7B00' }}>抵扣{Number(discountValue?.amount)}元</span>
                                            // : <span style={{ color: '#FF7B00' }}>折扣{Number(discountValue?.percent / 100).toFixed(2)}%</span>
                                            : <span style={{ color: '#FF7B00' }}>折扣{Number(discountValue?.percent / 10)}折</span>
                                    }
                                    {/* <span>，需新支付{(discountValue?.amount || discountValue?.percent) ? Number(selectVipPayObj?.price / 100).toFixed(2) : defaultVipObj[select][vipType?.vip_type]?.money}元，升级后即可生效</span> */}
                                    {/* <span>，需新支付{(discountValue?.amount || discountValue?.percent) ? Number(selectVipPayObj?.price / 100).toFixed(2) : Number(defaultVipObj[select][vipType?.vip_type]?.money / 100).toFixed(2)}元，升级后即可生效</span> */}
                                </div>
                            )
                            : null
                    }

                    {
                        selectVipPayObj?.url
                            ? (
                                <div className="iframe-wapper" style={{ marginTop: '28px' }}>
                                    {
                                        selectVipPaySuccess === 'paid'
                                            ? (
                                                <div className="iframe-cover">
                                                    <img style={{ width: '20px', height: '20px', marginRight: '8px' }} src={SUCCESS} /><span>已购买</span>
                                                </div>
                                            )
                                            : selectVipPaySuccess === 'expired'
                                                ? (
                                                    <div className="iframe-cover" style={{ flexDirection: 'column' }}>
                                                        <img style={{ width: '32px', height: '32px' }} src={LOAD} />
                                                        <span style={{ marginTop: '6px' }}>二维码已失效，请刷新重试</span>
                                                        <Button style={{ marginTop: '24px' }} type="primary" onClick={() => {
                                                            setSelectVipPaySuccess('')
                                                            setDiscountValue({});
                                                            workVipBuy(vipType)
                                                        }
                                                        }>刷新</Button>
                                                    </div>
                                                )
                                                : null
                                    }
                                    <iframe className="my-iframe" style={{ width: '222px', height: '222px', background: '#ffffff', border: '8px solid #ffffff', borderTop: '13px solid #ffffff', borderLeft: '13px solid #ffffff', borderRadius: '12px' }} src={selectVipPayObj?.url}>
                                    </iframe>
                                </div>
                            )
                            : null
                    }
                    <div className="price-model-money-footer" style={{ marginTop: '18px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff' }}>
                            <span>请扫码完成支付</span>
                            <img style={{ width: '16px', height: '16px', marginLeft: '4px' }} src={PAY_ICON} />
                        </div>
                        <div style={{ marginTop: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', lineHeight: '16px' }}>
                            <span style={{ color: '#808285' }}>您已同意</span><a href={PAY_LINK} target="_blank"><span style={{ color: '#aaacae', fontWeight: 500, cursor: 'pointer' }}>《“森宇宙好绘”付费服务协议》</span></a>
                        </div>
                    </div>
                    <Space direction="horizontal" style={{ marginTop: '32px' }}>
                        <Input size="large" value={selectVipDiscount} onChange={handleOnChange} style={{ color: '#ffffff', background: '#393c41', border: '1px solid rgba(255, 255, 255, 0.1)' }} placeholder="请输入折扣码" />
                        <div className="price-model-money-discount-button" style={selectVipDiscount ? { background: '#4671F4', color: '#FFFFFF', cursor: 'pointer' } : { background: '#364ea5', color: '#a6a8ab', cursor: 'not-allowed' }} onClick={selectVipDiscount ? handleUseDiscount : () => { }}>
                            <span>应用折扣</span>
                        </div>
                    </Space>
                </div>
            </Modal>
            {/* 联系销售弹框 */}
            {/* contact sales  */}
            <Modal
                className="contact-sales-modal"
                width={'300px'}
                title={null}
                footer={null}
                open={contactSalesOpen}
                maskClosable={false}
                onCancel={onCancelContace}
            >
                <div className="contact-sales-box">
                    <div className="contact-sales-kf-title">
                        扫码联系销售团队
                    </div>
                    <div className="contact-sales-kf-desc">
                        企业微信直连专属顾问
                    </div>
                    <img className="contact-sales-kf-img" style={{ width: '160px', height: '160px' }} src={QR_KF} />

                </div>
            </Modal>

            <Modal
                className="new-year-coupon-model"
                width={'420px'}
                title={null}
                footer={null}
                open={newYearCouponOpen}
                maskClosable={false}
                onCancel={handleNewYearCouponClose}
            >
                <div className="new-year-coupon-model-wapper">
                    <div className="new-year-coupon-model-title mb-6">
                        <div className="flex justify-center">恭喜! </div>
                        <div>您已获得8折优惠卷1张</div>
                    </div>
                    <img src={NewYearCoupon} style={{ width: '100%', marginBottom: '20px' }} />

                    <div className="text-[#fff]" style={{ marginTop: '12px', textAlign: 'center' }}>
                        优惠券折扣码已发送至您的邮箱，请及时领取。
                    </div>
                </div>
            </Modal>
            <Modal
                className="wechat-service-modal"
                width={'300px'}
                title={null}
                footer={null}
                open={wechatServiceOpen}
                maskClosable={false}
                onCancel={handleWechatServiceClose}
                style={{ position: 'fixed', bottom: '20px', right: '20px', top: 'auto', left: 'auto' }}
            >
                <div className="wechat-service-wapper">
                    <div className="wechat-service-title">
                        尊敬的会员，
                        <br />
                        专属VIP客服为您服务
                    </div>
                    <div className="wechat-service-desc">
                        请使用微信扫描二维码
                    </div>
                    <div className="wechat-service-qrcode">
                        <img src={QR_KF} style={{ width: '160px', height: '160px' }} />
                    </div>
                </div>
            </Modal>
            <ComputeUsageModal open={open3} onCannel={handleOpen3Close} payCountObj={payCountObj} />
        </>

    );
};

export default Price;
